import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'modules/icon-bank';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { errorNoPermissions as ErrorNoPermissions } from 'ui/views/generic/errorNoPermissions';
 *
 * // render
 * <ErrorNoPermissions propName='propValue'/>
 */
export const errorNoPermissions = ( props ) => {
    return (
        <div className='ui-error-no-permissions'>

            <div className='ui-error-no-permissions__container'>

                <div className='ui-error-no-permissions__container__logo'>
                    <Icon name='errorIconCross'/>
                </div>

                <div className='ui-error-no-permissions__container__text'>
                    { getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONT_HAVE_PERMISSIONS )}
                </div>

            </div>
           
        </div>
    );
};

// set display name
errorNoPermissions.displayName = 'errorNoPermissions';

// set default props
errorNoPermissions.defaultProps = {};

// prop types
errorNoPermissions.propTypes = {};
